export const environment = {
    production: 'https://mentorunion-api.getprepped.in'
,
    staging: 'https://api-test.getprepped.in'
,
    development: 'http://localhost:2023'

  }